//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbBreadcrumbs from './header/breadcrumbs/rb-breadcrumbs.vue'
import RbCrosslinksWrapper from './header/crosslinks/rb-crosslinks-wrapper.vue'
import RbPromoToggles from './header/promo-toggles/rb-promo-toggles.vue'
import RbFacetsCta from './header/facets/rb-facets-cta.vue'
import RbFacetsPanel from './header/facets/rb-facets-panel.vue'
import RbSortBy from './header/sort-by/rb-sort-by.vue'
import RbProducts from './rb-products.vue'
import RbNoResults from '@/elements/plp/no-results/rb-no-results.vue'
import RbLoadMore from './rb-load-more.vue'
import RbSeoRelatedLinks from '@/elements/seo/rb-seo-related-links.vue'
import RbSeoDescription from '@/elements/seo/rb-seo-description.vue'
import RbPlpWishlistModal from './rb-plp-wishlist-modal/rb-plp-wishlist-modal.vue'
import { createNamespacedHelpers, mapGetters } from 'vuex'

import { MOBILE, TABLET } from '@/scripts/constants/media-query'
import PLP from '@/scripts/libs/algolia/plp'
import PLPTrack from '@/scripts/libs/algolia/plp.track'
import QueryString from 'qs'
import { FACET_KEYS, PRICE_FILTER } from '@/scripts/constants/plp'
import { Url } from '@/scripts/libs/url'
import RbProductTile from '@/elements/product-tile/rb-product-tile.vue'
import { ACTION_UPDATE_PRODUCTS, ACTION_UPDATE_SEO_CONF } from '@/scripts/store/plp/actions'
import { ALL_PROMOS_LABEL } from '@/scripts/constants/promos'
const { mapActions: mapActionsPlp } = createNamespacedHelpers('plp')
import htmlFragment from '@/elements/html-fragment/html-fragment'
import wcs from '@/scripts/libs/wcs'
const { stickyStripeEnabled, stickyHeaderEnabled } = wcs.getStoreConfig()

export default {
  name: 'RbPlp',
  components: {
    RbNoResults,
    RbBreadcrumbs,
    RbCrosslinksWrapper,
    RbPromoToggles,
    RbFacetsCta,
    RbFacetsPanel,
    RbSortBy,
    RbProducts,
    RbLoadMore,
    RbSeoRelatedLinks,
    RbSeoDescription,
    RbProductTile,
    RbPlpWishlistModal,
    htmlFragment,
  },
  provide() {
    return {
      toggleFacets: this.toggleFacets,
      handleWishlistModal: this.handleWishlistModal,
      isPlpExclusive: this.isPlpExclusive,
      showFacetCount: this.showFacetCount,
    }
  },
  props: {
    breadcrumbs: {
      type: String,
      required: '',
    },
    elementId: {
      type: String,
      required: true,
    },
    hasRoxDisclaimer: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    productsFromSearch: Array,
    facetsFromSearch: Object,
    hasPromoPanel: {
      type: Boolean,
      default: false,
    },
    searchTerm: {
      type: String,
      default: '',
    },
    seoText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      facetsAreVisible: true,
      products: [],
      appliedFacets: [],
      appliedSortBy: '',
      ruleContext: '',
      facets: {},
      sortOptions: [],
      pageNumber: 1,
      totalCountFromSearch: 0,
      totalNumberOfProducts: 0,
      panelIsOpen: false,
      isNoResults: false,
      seoTitle: '',
      showWishlistModal: false,
      resetFacetPrice: false,
      firstToggle: ALL_PROMOS_LABEL,
      showFacetCount: false,
      promoStripeSticky: stickyStripeEnabled,
      headerSticky: stickyHeaderEnabled,
      scrollingDown: false,
      scrollingUp: false,
      lastScrollY: 0,
      slidingHeaderHeight: 0,
    }
  },
  computed: {
    ...mapGetters(['userLoggedIn']),
    disabledButtonFacetPanel() {
      return this.isMobile && this.totalNumberOfProducts === 0
    },
    isLoadMoreVisible() {
      return this.totalNumberOfProducts > this.products.length
    },
    readMoreElementId() {
      return `${this.elementId}_LoadMore`
    },
    productTileClass() {
      return this.isPlpExclusive ? 'col-12' : 'col-6 col-md-6 col-lg-4'
    },
    isPlpExclusive() {
      if (this.isInsideSearchPanel) {
        return false
      }

      return PLP.isPlpExclusive()
    },
    parsedBreadcrumbs() {
      if (!this.breadcrumbs) {
        return []
      }
      const parsedBreadcrumbsData = JSON.parse(this.breadcrumbs)
      const rawBreadcrumbs = parsedBreadcrumbsData?.templateData?.bredcrumbdata

      const breadcrumbs = rawBreadcrumbs?.map((breadcrumb, index) => ({
        link: breadcrumb?.details?.value,
        label: breadcrumb?.details?.label,
        isLast: index === rawBreadcrumbs?.length - 1,
      }))
      return [...breadcrumbs]
    },
    isMobile() {
      return [MOBILE, TABLET].includes(this.$mq)
    },
    isInsideSearchPanel() {
      return (
        (this.productsFromSearch && this.productsFromSearch.length > 0) ||
        this.facetsFromSearch ||
        !!this.totalCountFromSearch
      )
    },
    minPriceRange() {
      const priceFacet = this.mappedFacets?.find((facet) => facet.key === FACET_KEYS.PRICE)
      const minPriceRange = priceFacet?.values?.[0]?.min ?? 0
      return +minPriceRange
    },
    maxPriceRange() {
      const priceFacet = this.mappedFacets?.find((facet) => facet.key === FACET_KEYS.PRICE)
      const maxPriceRange = priceFacet?.values?.[0]?.max ?? 0
      return +maxPriceRange
    },
    mappedFacets() {
      return PLP.mapFacets({ facets: this.facets, appliedFacets: this.appliedFacets })
    },
    canShowBreadcrumbs() {
      return this.parsedBreadcrumbs.length !== 0
    },
    isUserLoggedIn() {
      return this.userLoggedIn
    },
  },
  watch: {
    facetsFromSearch: {
      immediate: true,
      handler(newVal) {
        if (newVal?.facets) {
          this.facets = { ...newVal.facets }
          this.totalNumberOfProducts = +newVal.totalCount ?? 0
          this.appliedFacets = newVal.appliedFacets?.entry ?? []
          this.sortOptions = newVal.sortOptions ?? []
          this.updateSeoConf({
            totalNumberOfProducts: this.totalNumberOfProducts,
          })
        }
      },
    },
    productsFromSearch: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.products = [...newVal]
        }
      },
    },
    filtersAreOpen(newVal) {
      this.setUiFiltersOpenStatus(newVal)
    },
    products(newVal) {
      if (this.isInsideSearchPanel) {
        return
      }

      this.updateProducts(newVal)
    },
  },
  mounted() {
    this.updateSeoConf({
      title: this.title,
      description: this.subtitle,
      totalNumberOfProducts: this.totalNumberOfProducts,
    })
  },
  async created() {
    PLP.setHitsPerPage(this.isMobile)

    this.facetsAreVisible = PLP.actionsAreVisible()
    window.addEventListener('popstate', this.handleBackButton)

    if (!this.isInsideSearchPanel) {
      this.appliedFacets = PLP.getAppliedFacets()
      this.appliedSortBy = PLP.getAppliedOrderCriteria()
      const { products, facets } = await this.loadPlpOnLanding()
      this.products = products || []
      this.isNoResults = !this.products.length
      this.facets = facets.facets
      this.totalNumberOfProducts = +facets?.totalCount
      this.sortOptions = facets?.sortOptions
      await this.updateSeoConf({
        totalNumberOfProducts: this.totalNumberOfProducts,
      })
      if (this.isMobile) {
        PLP.setSpeculationRuleMobile()
      }
      PLPTrack.trackLoadingReady(products, this.$ma)
    }

    await this.loadProductsByPageNumber()
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.handleBackButton)
  },
  methods: {
    ...mapActionsPlp({
      updateProducts: ACTION_UPDATE_PRODUCTS,
      updateSeoConf: ACTION_UPDATE_SEO_CONF,
    }),
    handleWishlistModal(wishlistedItems) {
      if (!this.isUserLoggedIn) {
        const isModalAlreadyShown = sessionStorage.getItem('guestUserWishlistModalShowed')
        if (wishlistedItems === 3 && !isModalAlreadyShown) {
          this.showWishlistModal = true
          sessionStorage.setItem('guestUserWishlistModalShowed', true)
        }
      }
    },
    closedPanel() {
      this.panelIsOpen = false
      if (this.appliedFacets.length > 0) {
        this.goTotop()
      }
    },
    async goTotop() {
      const rbProducts = document.querySelector('.rb-products')
      const headerAction = document.querySelector('.rb-plp-header__actions')
      const { offsetTop } = rbProducts
      const { offsetHeight } = headerAction
      const top = this.isMobile ? offsetTop : offsetTop + (offsetHeight - 15)
      await this.$nextTick()
      window.scrollTo({ top, behavior: 'smooth' })
    },
    closeWishlistModal() {
      this.showWishlistModal = false
    },
    async loadProductsByPageNumber() {
      const pageUrlParams = QueryString.parse(window.location.search.replace('?', ''))

      if (pageUrlParams?.pageNumber) {
        const pageNumber =
          typeof pageUrlParams.pageNumber === 'string'
            ? pageUrlParams.pageNumber
            : pageUrlParams.pageNumber[0]

        for (let i = 1; i < pageNumber; i++) {
          await this.loadMoreProducts(null)
        }
      }
    },
    async toggleFacets(facets, resetPrice, skipTrack) {
      this.resetFacetPrice = resetPrice
      const hasAppliedFacet = this.appliedFacets?.some((facet) => {
        if (Array.isArray(facet)) {
          return facet?.some((fc) => facets?.includes(fc))
        }
        return facets?.includes(facet)
      })
      if (hasAppliedFacet) {
        this.appliedFacets =
          this.appliedFacets?.filter((facet) => {
            if (Array.isArray(facet)) {
              const findValue = facet?.find((fc) => facets?.includes(fc)) ?? ''
              return !findValue
            }

            return !facets?.includes(facet)
          }) || []
      } else {
        const isPrice = PRICE_FILTER
        const isPriceActive =
          this.appliedFacets?.filter((facet) => facet?.includes(isPrice)).length > 0 &&
          facets?.some((facet) => facet.includes(isPrice))
        if (isPriceActive) {
          this.appliedFacets =
            this.appliedFacets?.filter((facet) => !facet?.includes(isPrice)) || []
          this.appliedFacets = [...this.appliedFacets, ...facets]
        } else {
          if (this.appliedFacets.length && Array.isArray(this.appliedFacets)) {
            this.appliedFacets = [...this.appliedFacets, ...facets]
          } else {
            this.appliedFacets = [...facets]
          }
        }
      }
      await this.goTotop()
      await this.applyFacets(skipTrack)
      this.updateUrl()
      this.resetFacetPrice = false
    },
    async applyFacets(skipTrack = false) {
      const data = await PLP.fetchCatalog({
        appliedFacets: this.appliedFacets,
        appliedOrderBy: this.appliedSortBy,
      })
      const { facets, products, totalCount } = data
      if (!skipTrack) {
        PLPTrack.trackSearchEvent(totalCount, this.appliedFacets, facets.facets, this.$ma)
      }
      this.facets = facets.facets
      this.products = products
      this.isNoResults = !this.products.length
      this.totalNumberOfProducts = totalCount
      await this.updateSeoConf({
        totalNumberOfProducts: this.totalNumberOfProducts,
      })
    },
    togglePanelFacets() {
      this.panelIsOpen = !this.panelIsOpen
    },
    async removeAllFacets() {
      this.resetFacetPrice = true
      this.appliedFacets = []
      await this.applyFacets()
      this.updateUrl()
      this.resetFacetPrice = false
      this.togglePanelFacets()
    },
    setSortOption(sortOption) {
      this.appliedSortBy = sortOption
      this.applyFacets()
      this.updateUrl()
    },
    async loadMoreProducts(e) {
      const data = await PLP.fetchMoreProducts({
        appliedFacets: this.appliedFacets,
        appliedOrderBy: this.appliedSortBy,
        pageNumber: this.pageNumber,
      })

      this.pageNumber++
      const { products, totalCount } = data
      this.updateUrl()

      this.products = this.products.concat(products)
      this.totalNumberOfProducts = totalCount
      await this.updateSeoConf({
        totalNumberOfProducts: this.totalNumberOfProducts,
      })

      if (this.isMobile || e?.pointerType === 'mouse' || e === null) {
        return
      }

      await this.$nextTick()
      this.$refs.products.focusFirstNewTileAfterLoadMore(this.pageNumber)
    },
    updateUrl() {
      if (this.isInsideSearchPanel) {
        return
      }

      Url.updateUrl({
        facet: this.appliedFacets,
        orderBy: this.appliedSortBy,
        pageNumber: this.pageNumber,
      })
    },
    handleBackButton() {
      if (this.appliedFacets.length > 0) {
        this.appliedFacets = PLP.getAppliedFacets()
        this.applyFacets()
      }
    },
    async loadPlpOnLanding() {
      return await PLP.fetchCatalog({
        appliedFacets: this.appliedFacets,
        appliedOrderBy: this.appliedSortBy,
        ruleContext: this.ruleContext,
      })
    },
  },
}
